import React from 'react';
import { ChevronDownIcon } from '@heroicons/react/24/outline';

interface PageLimitSelectorProps {
  currentLimit: number;
  onLimitChange: (limit: number) => void;
  isLoading: boolean;
}

const PageLimitSelector: React.FC<PageLimitSelectorProps> = ({ 
  currentLimit, 
  onLimitChange, 
  isLoading 
}) => {
  const limitOptions = [30, 60, 90, 100];

  return (
    <div className="flex items-center space-x-2">
      <label htmlFor="pageLimit" className="text-sm font-medium text-gray-700">
        Mostrar:
      </label>
      <div className="relative">
        <select
          id="pageLimit"
          value={currentLimit}
          onChange={(e) => onLimitChange(Number(e.target.value))}
          disabled={isLoading}
          className="appearance-none bg-white border border-gray-300 rounded-md py-1 pl-3 pr-8 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 disabled:opacity-50 disabled:cursor-not-allowed"
        >
          {limitOptions.map((limit) => (
            <option key={limit} value={limit}>
              {limit} por página
            </option>
          ))}
        </select>
        <div className="absolute inset-y-0 right-0 flex items-center pr-2 pointer-events-none">
          <ChevronDownIcon className="h-4 w-4 text-gray-400" />
        </div>
      </div>
    </div>
  );
};

export default PageLimitSelector;
